import Button from '@material-ui/core/Button';
import {ButtonProps} from '@material-ui/core';

function SearchButton({children, ...others}: ButtonProps) {
  return (
    <Button className="search-button" {...others}>
      {children}
    </Button>
  );
}

export default SearchButton;
